import React, {useState, useMemo, useRef, useEffect, useContext} from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import IntlStore, { Locale } from "stories/IntlStore";
import { Typography } from "ui-kit/Typography";
import english from 'assets/english.png';
import pt from 'assets/pt.png';
import hi from 'assets/hi.png';
import es from 'assets/es.png';
import TopArrow from 'assets/top-arrow.svg';
import BottomArrow from 'assets/bottom-arrow.svg';

export const LanguageSelect: React.FC = observer(() => {
  const [isOpen, setIsOpen] = useState(false);
  const selected = IntlStore.locale;
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Закрытие при клике вне
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const items = useMemo(() => ({
    [Locale.EN]: (
      <FlagContainer>
        <Flag src={english} alt="english" />
        <LanguageName variant="body1">ENG</LanguageName>
      </FlagContainer>
    ),
    [Locale.PT]: (
      <FlagContainer>
        <Flag src={pt} alt="english" />
        <LanguageName variant="body1">PT</LanguageName>
      </FlagContainer>
    ),
    [Locale.HI]: (
      <FlagContainer>
        <Flag src={hi} alt="english" />
        <LanguageName variant="body1">HI</LanguageName>
      </FlagContainer>
    ),
    [Locale.ES]: (
      <FlagContainer>
        <Flag src={es} alt="english" />
        <LanguageName variant="body1">ES</LanguageName>
      </FlagContainer>
    ),
    // [Locale.DE]: <Flag src="/german.png" alt="german" />,
    // [Locale.FR]: <Flag src="/france.png" alt="france" />,
    // [Locale.ZH]: <Flag src="/chinese.png" alt="chinese" />,
    // [Locale.JA]: <Flag src="/japanese.png" alt="japanese" />,
  } as Record<Locale, React.ReactNode>), []);

  const viewItems = useMemo(() => ({
    [Locale.EN]: <Flag src={english} alt="english" />,
    [Locale.PT]: <Flag src={pt} alt="english" />,
    [Locale.HI]: <Flag src={hi} alt="english" />,
    [Locale.ES]: <Flag src={es} alt="english" />,
    // [Locale.DE]: <Flag src="/german.png" alt="german" />,
    // [Locale.FR]: <Flag src="/france.png" alt="france" />,
    // [Locale.ZH]: <Flag src="/chinese.png" alt="chinese" />,
    // [Locale.JA]: <Flag src="/japanese.png" alt="japanese" />,
  } as Record<Locale, React.ReactNode>), []);

  const onToggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (lang: Locale) => {
    IntlStore.setLocale(lang);
    setIsOpen(false);
  };

  return (
    <Container ref={dropdownRef}>
      <Selected onClick={onToggleDropdown}>
        {viewItems[selected]}
        {isOpen ? (
          <Arrow>
            <TopArrow color="#000000" />
          </Arrow>
        ) : (
          <Arrow>
            <BottomArrow color="#000000" />
          </Arrow>
        )}
      </Selected>

      {isOpen && (
        <Dropdown>
          {Object.entries(items).map(([key, flag]) => (
            <Option key={key} onClick={() => handleSelect(key as Locale)}>
              {flag}
            </Option>
          ))}
        </Dropdown>
      )}
    </Container>
  );
});

const Container = styled.div`
  position: relative;
`;

const Selected = styled.div`
  display: flex;
  align-items: center;
  background: transparent;
  //padding: 6px 10px;
  gap: 8px;
  width: 55px;
  border-radius: 8px;
  cursor: pointer;
`;

const Dropdown = styled.div`
  position: absolute;
  top: 40px;
  left: 0;
  border-radius: 12px;
  padding: 6px 10px;
  overflow: hidden;
  z-index: 100;
  box-shadow: 0 0 8px 1px #0E0E0E40;
  background: #FFFFFF;
  width: 88px;
`;

const Option = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  cursor: pointer;
  //height: 33px;
  color: #000000;

  &:last-child {
    border: 0;
  }
`;

const Flag = styled.img`
  height: 20px;
  width: 32px;
`;

const Arrow = styled.div`
  //width: 16px;
  //height: 8px;
  //overflow: hidden;
  
  svg {
    width: 100%;
    height: 100%;
  }
`;

const FlagContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  width: fit-content;
  height: 20px;

  @media (max-width: 700px) {
    height: 28px;
    width: auto;
  }
`;

const LanguageName = styled(Typography)`
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;

`;
